// extracted by mini-css-extract-plugin
module.exports = {"imageCredit":"styles_imageCredit__1qbai"};